<wj-tab-panel class="full-size-tab" style="height:100%" [selectedIndex]="0" [isAnimated]="true"
              appWjTabStatePersist tabStateKey="dashboard-targets-main-tab"
>
    <wj-tab>
        <a>UW Strategy</a>
        <div class="layout-vbox">

            <div class="layout-hbox" style="gap: 50px; align-items: flex-start">
                <div>
                    <h4>Input</h4>
                    <wj-flex-grid #gridGeneralData style="width: auto"
                                  [allowSorting]="Wijmo.AllowSorting.None"
                                  [allowResizing]="Wijmo.AllowResizing.Columns"
                                  [headersVisibility]="Wijmo.HeadersVisibility.None" [selectionMode]="Wijmo.SelectionMode.CellRange"
                                  [isReadOnly]="true" [autoGenerateColumns]="false"
                                  appIntersectionObserver (intersectionCallback)="onGeneralDataGridInitialized(gridGeneralData)"
                    >
                    </wj-flex-grid>
                </div>

                <div>
                    <h4>Tiering KPIs Summary</h4>
                    <wj-flex-grid #gridTieringKpisSummary style="width: auto"
                                  [allowSorting]="Wijmo.AllowSorting.None" [autoRowHeights]="true"
                                  [allowResizing]="Wijmo.AllowResizing.Both"
                                  [headersVisibility]="Wijmo.HeadersVisibility.Column" [selectionMode]="Wijmo.SelectionMode.CellRange"
                                  [isReadOnly]="true" [autoGenerateColumns]="false"
                                  appIntersectionObserver (intersectionCallback)="onTieringKpisSummaryGridInitialized(gridTieringKpisSummary)"
                    >
                    </wj-flex-grid>
                </div>

                <div>
                    <h4>Tiering Ranges</h4>
                    <wj-flex-grid #gridTieringRanges style="width: auto"
                                  [allowSorting]="Wijmo.AllowSorting.None" [autoRowHeights]="false"
                                  [allowResizing]="Wijmo.AllowResizing.None"
                                  [headersVisibility]="Wijmo.HeadersVisibility.Column" [selectionMode]="Wijmo.SelectionMode.CellRange"
                                  [isReadOnly]="false" [autoGenerateColumns]="false"
                                  appIntersectionObserver (intersectionCallback)="onTieringRangesGridInitialized(gridTieringRanges)"
                    >
                    </wj-flex-grid>
                </div>
            </div>

            <div class="layout-hbox" style="gap: 50px; align-items: flex-start; margin-top: 20px">
                <div>
                    <h4 class="layout-hbox">
                        <span>Underwriting Strategy (Target Setting)</span>
                    </h4>
                    <wj-flex-grid #gridUwStrategy style="width: auto"
                                  [allowSorting]="Wijmo.AllowSorting.None" [autoRowHeights]="true"
                                  [allowResizing]="Wijmo.AllowResizing.None"
                                  [headersVisibility]="Wijmo.HeadersVisibility.Column" [selectionMode]="Wijmo.SelectionMode.CellRange"
                                  [isReadOnly]="false" [autoGenerateColumns]="false"
                                  appIntersectionObserver (intersectionCallback)="onUwStrategyGridInitialized(gridUwStrategy)"
                    >
                    </wj-flex-grid>
                </div>
            </div>

            <h3>Account Tiering Statistics</h3>

            <div class="layout-hbox" style="gap: 50px; align-items: flex-start; margin-top: 20px">
                <div class="layout-vbox">
                    <h4>Calculated PIL</h4>
                    <wj-flex-grid #gridCalculatedPil style="width: auto"
                                  [allowSorting]="Wijmo.AllowSorting.None" [autoRowHeights]="true"
                                  [allowResizing]="Wijmo.AllowResizing.None"
                                  [headersVisibility]="Wijmo.HeadersVisibility.Column" [selectionMode]="Wijmo.SelectionMode.CellRange"
                                  [isReadOnly]="true" [autoGenerateColumns]="false"
                                  appIntersectionObserver (intersectionCallback)="onCalculatedPilGridInitialized(gridCalculatedPil)"
                    >
                    </wj-flex-grid>

                    <h4 style="margin-top: 10px">Final PIL</h4>
                    <wj-flex-grid #gridFinalPil style="width: auto"
                                  [allowSorting]="Wijmo.AllowSorting.None" [autoRowHeights]="true"
                                  [allowResizing]="Wijmo.AllowResizing.None"
                                  [headersVisibility]="Wijmo.HeadersVisibility.Column" [selectionMode]="Wijmo.SelectionMode.CellRange"
                                  [isReadOnly]="true" [autoGenerateColumns]="false"
                                  appIntersectionObserver (intersectionCallback)="onFinalPilGridInitialized(gridFinalPil)"
                    >
                    </wj-flex-grid>

                    <h4 style="margin-top: 10px">Last Year PIL</h4>
                    <wj-flex-grid #gridLastYearPil style="width: auto"
                                  [allowSorting]="Wijmo.AllowSorting.None" [autoRowHeights]="true"
                                  [allowResizing]="Wijmo.AllowResizing.None"
                                  [headersVisibility]="Wijmo.HeadersVisibility.Column" [selectionMode]="Wijmo.SelectionMode.CellRange"
                                  [isReadOnly]="true" [autoGenerateColumns]="false"
                                  appIntersectionObserver (intersectionCallback)="onLastYearPilGridInitialized(gridLastYearPil)"
                    >
                    </wj-flex-grid>

                </div>

                <div>
                    <app-ats-scatter-chart [data]="atsChartData()" [ranges]="atsChartRanges()"
                                           appSegmentDataObserver
                                           style="width: 650px; height: 400px"></app-ats-scatter-chart>
                </div>
            </div>
        </div>
    </wj-tab>

    <wj-tab>
        <a>KPIs Distribution</a>
        <div class="layout-vbox kpi-charts-container" style="align-items: flex-start; overflow: auto">
            <div>
            </div>

            @for (kpiChart of kpiCharts(); track kpiChart.kpi.kpiKey) {
                @let kpi = kpiChart.kpi;

                <div style="margin: 0 0 5px 0;">
                    <b>{{kpi.name}}</b> (weighted {{kpi.weight | percent:'1.0-1'}})
                </div>
                <div style="margin-bottom: 10px; max-width: 800px; font-size: 12px; color: #666;">
                    <em>{{kpi.definition}}</em>:
                    {{kpi.interpretation}}


                    <span style="white-space: nowrap">
                        (<span [innerHtml]=DataDictionaryService.kpiDirectionIcon(kpi.directionAscending)></span>
                        @if (kpi.directionAscending) { higher } @else { lower }
                    </span>
                    is better
                    )
                </div>
                <div class="layout-hbox" style="gap: 10px; justify-content: flex-start; align-items: flex-start;">

                    @if (kpiChart.type === 'Discrete') {
                        <!-- Discrete Charts are pie charts, where each segment represents the concrete value of the KPI -->
                        <wj-flex-pie #chart10 [header]="'GNWP [mio EUR]'" [itemsSource]="kpiChart.data" [bindingName]="'key'" [binding]="'gnwpEur'"
                                     [innerRadius]="0.5" [palette]="GeneraliPieChartPalette"
                                     (dblclick)="onChartClick(kpiChart, chart10, $event)" (initialized)="onChartInitialized(chart10)"
                        >
                            <wj-flex-pie-data-label [position]="Wijmo.PieLabelPosition.Inside" [content]="getLabelContent"></wj-flex-pie-data-label>
                        </wj-flex-pie>

                        <wj-flex-pie #chart11 [header]="'Number of Accounts'" [itemsSource]="kpiChart.data" [bindingName]="'key'" [binding]="'count'"
                                     [innerRadius]="0.5" [palette]="GeneraliPieChartPalette"  (initialized)="onChartInitialized(chart11)"
                                     (dblclick)="onChartClick(kpiChart, chart11, $event)"
                        >
                            <wj-flex-pie-data-label [position]="Wijmo.PieLabelPosition.Inside" [content]="getLabelContentCount"></wj-flex-pie-data-label>
                        </wj-flex-pie>
                    }
                    @else if (kpiChart.type === 'Continuous') {
                        <!-- Continuous Charts are bar charts, where each bar is a rabge from a histogram of the KPI values-->
                        <wj-flex-chart #chart21 [bindingX]="'name'" [header]="'GNWP [mio EUR]'"
                                       (dblclick)="onChartClick(kpiChart, chart21, $event)"
                                       [itemsSource]="kpiChart.data" (initialized)="onChartInitialized(chart21)"
                                       [itemFormatter]="GeneraliColumnChartPaletteItemFormatter">
                            <wj-flex-chart-legend [position]="Wijmo.Position.None"></wj-flex-chart-legend>
                            <wj-flex-chart-axis wjProperty="axisY" [position]="Wijmo.Position.Right" format="n0,,"></wj-flex-chart-axis>
                            <wj-flex-chart-axis wjProperty="axisX" [position]="Wijmo.Position.Bottom" [labelAngle]="-45"></wj-flex-chart-axis>
                            <wj-flex-chart-series name="GNWP" binding="gnwpEur"></wj-flex-chart-series>
                            <wj-flex-chart-data-label content="{gnwpEur:'n1,,'}" [position]="Wijmo.LabelPosition.Top"></wj-flex-chart-data-label>
                            <!-- for now  - do not activate chart gestures
                            <wj-flex-chart-gestures [interactiveAxes]="Wijmo.InteractiveAxes.XY" [mouseAction]="Wijmo.MouseAction.Zoom">
                            </wj-flex-chart-gestures>
                             -->
                        </wj-flex-chart>

                        <wj-flex-chart #chart22 [bindingX]="'name'" [header]="'Number of Accounts'"
                                       (dblclick)="onChartClick(kpiChart, chart22, $event)"
                                       [itemsSource]="kpiChart.data" (initialized)="onChartInitialized(chart22)"
                                       [itemFormatter]="GeneraliColumnChartPaletteItemFormatter">
                            <wj-flex-chart-legend [position]="Wijmo.Position.None"></wj-flex-chart-legend>
                            <wj-flex-chart-axis wjProperty="axisY" [position]="Wijmo.Position.Left"></wj-flex-chart-axis>
                            <wj-flex-chart-axis wjProperty="axisX" [position]="Wijmo.Position.Bottom" [labelAngle]="-45"></wj-flex-chart-axis>
                            <wj-flex-chart-series name="Count" binding="count"></wj-flex-chart-series>
                            <wj-flex-chart-data-label content="{count:n}" [position]="Wijmo.LabelPosition.Top"></wj-flex-chart-data-label>

                            <!-- for now  - do not activate chart gestures
                            <wj-flex-chart-gestures [interactiveAxes]="Wijmo.InteractiveAxes.XY" [mouseAction]="Wijmo.MouseAction.Zoom">
                            </wj-flex-chart-gestures>
                             -->
                        </wj-flex-chart>

                        <!-- The histogram can be controlled in terms of 1) number of buckets and 2) removal of outliers -->
                        <div class="outlier-controls">
                            <div class="vertical-textbox">Q</div>
                            <fluent-slider #quantileSlider orientation="vertical" mode="single-value" min="0" max="0.1" step="0.01"
                                           [value]="kpiChart.outlierQuantile"
                                           (change)="onOutlierQuantileChange(chart21, chart22, kpiChart, 'outlierQuantile', quantileSlider)"
                                           title="Increase to remove outliers"
                            >

                            </fluent-slider>
                            <div class="vertical-textbox">{{kpiChart.outlierQuantile | percent: '1.0-1' }}</div>

                            <div class="vertical-textbox">Buckets</div>
                            <fluent-slider #bucketSlider orientation="vertical" mode="single-value" min="5" max="50" step="5"
                                           value="{{kpiChart.numBuckets}}"
                                           (change)="onOutlierQuantileChange(chart21, chart22, kpiChart, 'numBuckets', bucketSlider)"
                                           title="Increase for finer granularity"
                            >
                            </fluent-slider>
                            <div class="vertical-textbox">{{kpiChart.numBuckets}}</div>
                        </div>
                    }
                </div>
            }
        </div>
    </wj-tab>
</wj-tab-panel>
